import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logoIcon from "assets/logo.png";
import UserAction from "components/UserAction";
import Searchs from "components/Search";
import { HeaderWrapper } from "./style";
import { sysInfo } from "api/user";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    sysInfo().then();
  }, []);

  // 监听滚动事件，添加模糊背景效果
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);

  return (
    <HeaderWrapper className={scrolled ? "scrolled" : ""}>
      <div className="header_main">
        <div className="logo">
          <Link to="/" className="logo-link">
            <div className="logo-icon">
              <img src={logoIcon} alt="Lamp-亮" />
            </div>
            <span className="logo-text">
              <span className="logo-sub">amp-亮</span>
            </span>
          </Link>
        </div>

        <div className="header_right">
          <Searchs />
          {/* <UserAction /> */}
        </div>
      </div>
    </HeaderWrapper>
  );
};
